import React from "react";
// import Link from "gatsby-link";
// import Helmet from "react-helmet";
// import styled from "styled-components";
import componentQueries from "react-component-queries";
import { Flex, Box } from "rebass";
import GlobalSeo from "../templates/meta";
import Overlay from "../components/overlay";
import Image from "../components/image";

export default componentQueries(({ width }) => {
  const layoutProps = (function mapWidthToLayoutProps() {
    const dFault = {
      image: {
        w: "100%"
      },
      text: {
        f: 11,
        w: 1,
        mb: 15
      },
      contact: {
        f: 11,
        w: 1
      }
    };

    if (width > 1000) {
      return {
        image: {
          w: "60%"
        },
        text: {
          f: 8,
          w: 2 / 3
        },
        contact: {
          f: 6,
          w: 1 / 3,
          justify: "center"
        }
      };
    }

    if (width > 500) {
      return {
        image: {
          w: "80%"
        },
        text: {
          f: 9,
          w: 1,
          mb: 13
        },
        contact: {
          f: 8,
          w: 1
        }
      };
    }

    return dFault;
  })();

  return {
    layoutProps
  };
})(props => {
  const { contact, text, image } = props.data.allAbout.edges[0].node;
  const { globalSeo } = props.data;
  const { layoutProps } = props;
  return (
    <Flex
      style={{ backgroundColor: "transparent" }}
      justify="center"
      pt={"0vh"}
    >
      <Box w="80%">
        <GlobalSeo {...globalSeo} />
        <Overlay elements={[["RO"], ["Architecten"], ["&"], ["AD"]]} />
        <Box w={layoutProps.image.w} pb="5rem">
          <Image file={image} />
        </Box>
        <Flex wrap justify="space-around">
          <Box
            pr={"3vw"}
            f={layoutProps.text.f}
            w={layoutProps.text.w}
            mb={layoutProps.text.mb}
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <Box f={layoutProps.contact.f} w={layoutProps.contact.w}>
            <Flex justify={layoutProps.contact.justify}>
              <Box dangerouslySetInnerHTML={{ __html: contact }} />
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
});

export const pageQuery = graphql`
  query About {
    allAbout {
      edges {
        node {
          contact
          text
          image {
            url
          }
        }
      }
    }
    globalSeo {
      en {
        siteName
        titleSuffix
        fallbackSeo {
          title
          description
          image {
            path
          }
        }
      }
      favicon {
        path
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/over.js